import { render, staticRenderFns } from "./StoreMailOrderList.vue?vue&type=template&id=08501cd6&scoped=true&"
import script from "./StoreMailOrderList.vue?vue&type=script&lang=js&"
export * from "./StoreMailOrderList.vue?vue&type=script&lang=js&"
import style0 from "./StoreMailOrderList.vue?vue&type=style&index=0&id=08501cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08501cd6",
  null
  
)

export default component.exports